import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { PocketMoneyBG } from "@assets";

export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		border: none !important;
		background-image: url(${PocketMoneyBG}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		width: 365px !important;
		height: 423px !important;
		/* height: 3px; */
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px !important;
			height: 323px !important;
		}
	}
`;

export const ModalTitle = styled.p`
	color: #ffffff;
	font-size: 22px;
	font-weight: 600;
	line-height: 33px;
	margin-top: 56px;
	margin-bottom: 8px;
	@media screen and (max-width: 413px) {
		margin-bottom: 4px;
		margin-top: 45px;
		font-size: 18px;
		font-weight: 500;
		line-height: 25px;
	}
`;

export const ModalLabel = styled.p`
	text-align: center;
	font-weight: 400;
	font-size: 14px;
	line-height: 24px;
	color: #e8a442;
	margin-bottom: 15px;
	@media screen and (max-width: 413px) {
		margin-bottom: 8px;
		font-weight: 300;
		font-size: 12px;
		line-height: 20px;
	}
`;

export const AmountWrapper = styled.div`
	font-weight: 600;
	font-size: 20px;
	line-height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 238px !important;
	height: 47px !important;
	border-radius: 12px !important;
	background: linear-gradient(20deg, #c7831f 0%, #ffb930 100%);
	@media screen and (max-width: 413px) {
		width: 150px !important;
		height: 30px !important;
		border-radius: 8px !important;
		font-weight: 500;
		font-size: 16px;
		line-height: 25px;
	}
`;

export const OkWrapper = styled.div`
	width: 238px;
	height: 39px;
	border: 1px solid #ffffff;
	border-radius: 12px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	cursor: pointer;
	@media screen and (max-width: 413px) {
		width: 150px !important;
		height: 30px !important;
		margin-top: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
	}
`;

export const ExpiredText = styled.div`
	font-size: 12px;
	font-weight: 400;
	line-height: 18px;
	margin-top: 75px;
	color: #ffffff;
	@media screen and (max-width: 413px) {
		margin-top: 40px;
		font-size: 8px;
		font-weight: 200;
		line-height: 15px;
	}
`;

export const ExpiredDate = styled.span`
	color: #e8a442;
`;
